// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_gqp","cls2":"Filter-cls2_4N- Filter-cls1_gqp"};